export enum ConfirmAppointmentReminderOptions {
  ON = 'default-on',
  OFF = 'default-off',
  DISABLED = 'never',
  ENABLED = 'always'
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/enums/reminder_enum.ts